import { inject } from '@angular/core';
import { ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { LoadingSpinnerService } from './loading-spinner.service';

export const loadingSpinnerResolver: ResolveFn<boolean> = (
  _route,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const loadingSpinnerService = inject(LoadingSpinnerService);

  if (!state.url.includes('/overview') && !state.url.includes('/callback')) {
    if (loadingSpinnerService.active) {
      loadingSpinnerService.stop();
    }
  }
  const spinner = document.getElementById('global-spinner');
  if (spinner) spinner.innerHTML = '';
  return of(true);
};
